<template>
  <div class="login">
    <particle />
    <el-form :model="loginForm" :rules="rules" ref="loginForm">
      <div class="login-box">
        <div class="login-type">
          <el-button @click="loginTypeChangeHandler" type="text">{{ loginType.text }} &nbsp;&gt;</el-button>
        </div>
        <img :src="loginType.logoUrl" class="logo" alt="logo" />
        <p class="slogan">{{ loginType.desc }}</p>
        <el-form-item prop="userName">
          <el-input v-model="loginForm.userName" auto-complete="off" placeholder="请输入手机号码">
            <i class="el-icon-user el-input__icon" :style="iconStyle" slot="prefix"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="password"
            auto-complete="off"
            v-model="loginForm.password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="login"
          >
            <i class="el-icon-lock el-input__icon" :style="iconStyle" slot="prefix"></i>
          </el-input>
        </el-form-item>
        <el-button type="primary" class="login-btn" @click="login">登 录</el-button>
        <div class="register-forget__wrapper">
          <div class="register-now__wrapper">
            <span>忘记密码？</span>
            <router-link to="/register">立即注册</router-link>
            <!-- <a href="javascript:;">立即注册</a> -->
          </div>
          <a href="javascript: void(0);" @click="forgetPassword">忘记密码？</a>
        </div>
      </div>
    </el-form>

    <!-- 获取验证码 -->
    <el-dialog
      title="忘记密码"
      :visible.sync="changePasswordVisible"
      width="430px"
      top="30vh"
      @closed="changePasswordCancel('changePasswordForm')"
      :modal-append-to-body="false"
    >
      <el-form :model="changePasswordForm" :rules="forgetRules" ref="changePasswordForm">
        <el-form-item prop="phone" class="flex-box">
          <el-input
            v-model="changePasswordForm.phone"
            autocomplete="off"
            @keyup.space.native="noSpace"
            placeholder="请输入手机号码"
            clearable
            class="fl w60"
          ></el-input>
          <el-button
            type="primary"
            @click="getVerificationCode('changePasswordForm','phone')"
            class="fr w33"
            v-show="verificationBtn"
          >获取验证码</el-button>
          <el-button
            type="info"
            disabled
            class="fr w33"
            v-show="!verificationBtn"
          >{{timeNumber}}s重新发送</el-button>
        </el-form-item>
        <el-form-item prop="verificationCode" class="m-t-20">
          <el-input
            v-model="changePasswordForm.verificationCode"
            autocomplete="off"
            @keyup.space.native="noSpace"
            placeholder="请输入短信验证码"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="changePasswordCancel('changePasswordForm')">取 消</el-button>
        <el-button type="primary" @click="next('changePasswordForm')">下一步</el-button>
      </div>
    </el-dialog>

    <!-- 设置新密码 -->
    <el-dialog
      title="忘记密码"
      :visible.sync="newPasswordVisible"
      width="430px"
      top="30vh"
      @closed="submitCancel('newPasswordForm')"
      :modal-append-to-body="false"
    >
      <el-form :model="newPasswordForm" :rules="forgetRules" ref="newPasswordForm">
        <el-form-item prop="newPassword">
          <el-input
            v-model="newPasswordForm.newPassword"
            autocomplete="off"
            @keyup.space.native="noSpace"
            placeholder="请输入新密码"
            clearable
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="passwordAgain" class="m-t-20">
          <el-input
            v-model="newPasswordForm.passwordAgain"
            autocomplete="off"
            @keyup.space.native="noSpace"
            placeholder="请再次输入新密码"
            clearable
            type="password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="submitCancel('newPasswordForm')">取 消</el-button>
        <el-button type="primary" @click="submit('newPasswordForm')">确 定</el-button>
      </div>
    </el-dialog>
    <pub-footer />
  </div>
</template>

<script>
import particle from "@/components/particles";
import pubFooter from "@/components/footer";
import { options } from "../assets/tools/config";
import {
  userLogin,
  sendSmsCode,
  checkSmsCode,
  changePassword
} from "@/assets/js/api";

const logoFactory = require("../assets/images/adam-login-logo.png");
const logoIdea = require("../assets/images/adam-login-logo-manager.png");

import { LOADING_OPTIONS } from "../assets/tools/common";
import { getMenuList } from "../assets/js/api";
export default {
  name: "app",
  components: {
    particle,
    pubFooter
  },
  data() {
    // 手机号校验规则
    var validatorPhone = (rule, value, callback) => {
      if (!value) {
        return callback();
      } else if (
        value !== "" &&
        !/^1[3456789]\d{9}$/.test(this.changePasswordForm.phone)
      ) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    // 接口返回错误
    var resValidate = (rule, value, callback) => {
      if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    // 密码校验规则
    var validatorPassword = (rule, value, callback) => {
      if (!value) {
        return callback();
      } else if (
        value !== "" &&
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(
          this.newPasswordForm.newPassword
        )
      ) {
        return callback(new Error("请输入6-20位字母+数字组合"));
      }
      callback();
    };
    // 密码校验规则
    var validatorPasswordAgain = (rule, value, callback) => {
      if (!value) {
        return callback();
      } else if (value !== "" && value !== this.newPasswordForm.newPassword) {
        return callback(new Error("两次密码不一致"));
      }
      callback();
    };

    return {
      forgetPassShow: false,
      loginForm: {
        userName: "",
        password: ""
      },
      iconStyle: options.inputIconPrefixStyle,
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      timeNumber: 60,
      verificationBtn: true,
      changePasswordVisible: false,
      changePasswordForm: {
        phone: "",
        verificationCode: ""
      },
      newPasswordVisible: false,
      newPasswordForm: {
        username: "",
        newPassword: "",
        passwordAgain: ""
      },
      forgetRules: {
        username: [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: resValidate }
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: validatorPhone, trigger: "blur" }
        ],
        verificationCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { validator: resValidate }
        ],
        newPassword: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: validatorPassword, trigger: "blur" }
        ],
        passwordAgain: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: validatorPasswordAgain, trigger: "blur" }
        ]
      },
      loginType: {
        text: "创意管理",
        desc: "汇聚最新的精品创意",
        mode: 1,
        logoUrl: logoFactory
      }
    };
  },
  created() {
    if (window.location.href.indexOf("/dashboard/shopify/feed") > -1) {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/dashboard/shopify/feed" +
        window.location.search;
    } else if (window.location.href.indexOf("/account-bind/true") > -1) {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/account-bind/true" +
        window.location.search;
    } else {
      localStorage.token = "";
    }

    this.isQuickLoginHandler();
  },
  methods: {
    // 登录类型
    loginTypeChangeHandler() {
      if (this.loginType.mode === 1) {
        this.loginType = {
          mode: 2,
          text: "创意工厂",
          desc: "上传-管理精品创意",
          logoUrl: logoIdea
        };
      } else {
        this.loginType = {
          mode: 1,
          text: "创意管理",
          desc: "汇聚最新的精品创意",
          logoUrl: logoFactory
        };
      }
    },
    // 判断是否快捷登录
    async isQuickLoginHandler() {
      const { query } = this.$route;

      // 如地址栏中 token 存在则直接调用登录接口实现快捷登录
      if (query.token) {
        const res = await userLogin({ accessToken: query.token });
        this.afterLoginHandler(res);
      }
    },
    // 忘记密码
    forgetPassword() {
      this.changePasswordVisible = true;
    },
    // 获取验证码
    getVerificationCode(formRef, propName) {
      this.$refs[formRef].validateField(propName, async phone => {
        if (!phone) {
          const res = await sendSmsCode(this.changePasswordForm.phone);
          if (res.code === 200) {
            this.$message.success("验证码已发送至手机，请注意查收");
            this.verificationBtn = false;
            this.interval = setInterval(() => {
              if (this.timeNumber <= 0) {
                this.timeNumber = 60;
                clearInterval(this.interval);
                this.verificationBtn = true;
              } else {
                this.timeNumber--;
              }
            }, 1000);
          } else {
            this.$notify.error({
              title: "获取验证码",
              message: res.msg
            });
          }
        }
      });
    },
    // 忘记密码-取消
    changePasswordCancel(changePasswordForm) {
      this.$refs[changePasswordForm].resetFields();
      this.changePasswordVisible = false;
    },
    // 忘记密码-下一步
    next(changePasswordForm) {
      var params = {
        phone: this.changePasswordForm.phone,
        code: this.changePasswordForm.verificationCode
      };
      this.$refs[changePasswordForm].validate(async valid => {
        if (valid) {
          const res = await checkSmsCode(params);
          if (res.code == 200) {
            (this.newPasswordForm.username = this.changePasswordForm.phone),
              this.$refs[changePasswordForm].resetFields();
            this.changePasswordVisible = false;
            this.newPasswordVisible = true;
          } else {
            this.$notify.error({
              title: "验证验证码",
              message: res.msg
            });
          }
        }
      });
    },

    // 新密码-取消
    submitCancel(newPasswordForm) {
      this.$refs[newPasswordForm].resetFields();
      this.newPasswordVisible = false;
    },
    // 确认新密码
    submit(newPasswordForm) {
      var params = {
        userName: this.newPasswordForm.username,
        password: this.newPasswordForm.newPassword
      };
      this.$refs[newPasswordForm].validate(async valid => {
        if (valid) {
          const res = await changePassword(params);
          if (res.code == 200) {
            this.$refs[newPasswordForm].resetFields();
            this.newPasswordVisible = false;
            this.$message.success("修改密码成功!");
          } else {
            this.$notify.error({
              title: "设置新密码",
              message: res.msg
            });
          }
        }
      });
    },
    // 禁止输入空格
    noSpace() {
      this.loginForm.username = this.loginForm.username.replace(
        /(^\s+)|(\s+$)/g,
        ""
      );
      this.loginForm.password = this.loginForm.password.replace(
        /(^\s+)|(\s+$)/g,
        ""
      );
    },
    login() {
      this.$refs["loginForm"].validate(async valid => {
        if (valid) {
          const loading = this.$loading({
            ...LOADING_OPTIONS,
            text: "正在登录，请稍候..."
          });
          const data = await userLogin({
            ...this.loginForm,
            platform: this.loginType.mode
          });

          this.afterLoginHandler(data);

          this.$nextTick(() => {
            loading.close();
          });
        }
      });
      // const data = await userLogin(this.userName, this.password);
      // this.msg = data.code !== 0 ? data.msg : "登录成功";
      // this.msgType = data.code === 0 ? "success" : "warning";
      // this.msgShow = true;
    },
    // 登录请求成功后的处理事件
    async afterLoginHandler(data) {
      if (data.code === 0) {
        localStorage.setItem("token", data.data.token);
        sessionStorage.setItem("token", data.data.token);
        localStorage.setItem("userInfo", JSON.stringify(data.data));
        const result = await getMenuList();

        if (result.data && result.data.length > 0) {
          // 添加验证是否有菜单
          // let isChildren = false
          // result.data.map(item => {
          //   if (item.children && item.children.length) {
          //     isChildren = true
          //   }
          // })

          // if (!isChildren) {
          //   this.$message.error('未分配菜单')
          //   return
          // }

          localStorage.setItem("menuList", JSON.stringify(result.data));
          // 登录成功，跳转至首页
          let indexFlag = false,
            managerFlag = false;

          result.data.map(item => {
            item.children.map(it => {
              if (
                it.url === "/index" ||
                it.url === "/third-party-material" ||
                it.url === "/material-library"
              ) {
                indexFlag = true;
              } else if (it.url === "/file-manager") {
                managerFlag = true;
              }
            });
          });

          // if (
          //   (indexFlag && this.loginType.mode === 1) ||
          //   (managerFlag && this.loginType.mode === 2)
          // ) {
          //   this.$message({
          //     showClose: true,
          //     message: data.code !== 0 ? data.msg : "登录成功",
          //     type: data.code === 0 ? "success" : "warning"
          //   });
          // }

          // 此处根据登录类型判断跳转
          if (this.loginType.mode === 1) {
            if (indexFlag) {
              const projectId = this.$route.query.projectId
              if(projectId){
                this.$router.push(`/material-library?projectId=${projectId}`)
                return
              }
              this.$router.push("/");
            } else {
              this.$message({
                showClose: true,
                message: "该用户未分配权限",
                type: "error"
              });
            }
          } else {
            if (managerFlag) {
              this.$router.push("/file-manager");
            } else {
              this.$message({
                showClose: true,
                message: "该用户未分配权限",
                type: "error"
              });
            }
          }
        } else {
          this.$message({
            showClose: true,
            message: "该用户未分配权限",
            type: "error"
          });
        }

        // localStorage.token = data.data.token
        // localStorage.userName = data.data.userName
        // if (data.data.is_bind || data.data.fb_is_bind) {
        //   this.$router.push('/dashboard/ad/overview')
        // } else {
        //   this.$router.push('/account-bind/false')
        // }
      } else {
        this.$message({
          showClose: true,
          message: data.msg,
          type: "error"
        });
      }
    },
    msgClose() {
      this.msgShow = false;
    }
  }
};
</script>

<style lang="scss">
.fl {
  float: left;
}
.fr {
  float: right;
}
.w60 {
  width: 60% !important;
}
.w33 {
  width: 33% !important;
}
.m-t-20 {
  margin-top: 20px;
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  text-align: left;

  .login-type {
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-button {
    height: 40px;
  }

  input {
    text-indent: 0;
  }

  .login-box {
    width: 420px;
    height: 500px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 60px 92px;
    position: relative;
    z-index: 2;
    box-shadow: 0px 3px 20px rgba(160, 170, 199, 0.2);
    opacity: 1;
    border-radius: 10px;
    .slogan {
      margin: 0 0 40px;
      color: #c0c4cc;
      font-size: 14px;
      text-align: center;
    }
    img {
      margin: 0 auto 20px;
      display: block;
    }
    input {
      font-size: 14px;
    }
    .password {
      margin-top: 20px;
      .el-icon-view {
        color: #2290ff;
      }
    }
    .login-btn {
      margin: 50px 0 30px;
      background: linear-gradient(
        90deg,
        rgba(25, 131, 249, 1) 0%,
        rgba(112, 48, 255, 1) 100%
      );
      border: 0;
      width: 100%;
      min-height: 38px;
    }

    a {
      color: #1983f9;
      font-size: 14px;
      width: 76px;
      text-align: center;
      // display: block;
      // margin: 0 auto;
    }

    .register-forget__wrapper {
      display: flex;
      justify-content: space-between;

      span {
        color: #606266;
      }
    }
  }
}
</style>
